export const firstMenuPathList = ['/Login', '/SearchEngine', '/IntelligenceField']